import { Link } from "react-router-dom";
import { useAuthForm } from "@/hooks/useAuthForm";
import { Button } from "@/components/ui/button";
import { RoleSelector, AuthFields } from "@/components/auth/AuthFields";
import { Loader2 } from "lucide-react";

export default function AuthForm() {
  const { mode, role, setRole, form, upd, error, loading, submit, toggleMode } = useAuthForm();
  const isLogin = mode === "login";

  return (
    <div className="w-full max-w-sm">
      <Link to="/" className="font-serif text-xl text-zinc-900 lg:hidden">Medical CDSS</Link>
      <h1 className="mt-4 font-serif text-3xl tracking-tight text-zinc-900">
        {isLogin ? "Sign in" : "Create account"}
      </h1>
      <p className="mt-2 text-sm text-zinc-500">
        {isLogin ? "Access the diagnostic workflow." : "Register as a patient or doctor."}
      </p>

      <RoleSelector role={role} setRole={setRole} />

      <form onSubmit={submit} className="mt-6 space-y-4">
        <AuthFields mode={mode} form={form} upd={upd} error={error} />
        <Button type="submit" data-testid="auth-submit-btn" disabled={loading} className="w-full bg-[#002FA7] hover:bg-[#002687] text-white h-11">
          {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
          {isLogin ? "Sign in" : "Create account"}
        </Button>
      </form>

      <p className="mt-6 text-sm text-zinc-500 text-center">
        {isLogin ? "No account yet?" : "Already registered?"}{" "}
        <button data-testid="toggle-mode-btn" onClick={toggleMode} className="text-[#002FA7] font-medium hover:underline">
          {isLogin ? "Register" : "Sign in"}
        </button>
      </p>
    </div>
  );
}
